import { render, staticRenderFns } from "./AdventureTour5.vue?vue&type=template&id=45f08d8c&scoped=true&"
import script from "./AdventureTour5.vue?vue&type=script&lang=ts&"
export * from "./AdventureTour5.vue?vue&type=script&lang=ts&"
import style0 from "./AdventureTour5.vue?vue&type=style&index=0&id=45f08d8c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45f08d8c",
  null
  
)

export default component.exports